import DisqusThreadComments from 'modules/common/DisqusThreadComments';
import Tabs from 'modules/common/Tabs';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import Description from './Description';
import Downloads from './Downloads';
import Iframe from './Iframe';
import Note from './Note';
import {notificationIcon, numCount} from './styles.scss';

const TabbedContent = ({
  videoId,
  description,
  downloads,
  note,
  access_token,
  isDisplayRepl,
  trackSlug,
  stepId,
  trackTopicName,
}) => {
  let language = '';
  if (trackTopicName === 'Android' || trackTopicName === 'Java') {
    language = 'Java';
  } else if (trackTopicName === 'Django') {
    language = 'Django';
  } else if (trackTopicName === 'C++') {
    language = 'Cpp';
  } else if (trackTopicName === 'Python') {
    language = 'Python';
  }

  return (
    <Tabs
      titles={[
        <FormattedMessage id="summary" />,
        <div className="flex">
          <span className="mt2">
            <FormattedMessage id="ide" />
          </span>
          <div className={`${notificationIcon}`}>
            <span className={numCount}>!</span>
          </div>
        </div>,
        <FormattedMessage id="notes" />,
        <FormattedMessage id="downloads" />,
        <FormattedMessage id="question_and_answer" />,
      ]}
      contents={[
        description && <Description description={description} />,
        trackSlug && isDisplayRepl && (
          <Iframe track={language} stepId={stepId} />
        ),
        note && <Note note={note} />,
        downloads && downloads.edges && downloads.edges.length > 0 && (
          <Downloads downloads={downloads} />
        ),
        videoId && access_token && (
          <DisqusThreadComments videoId={videoId} access_token={access_token} />
        ),
      ]}
    />
  );
};

TabbedContent.propTypes = {
  videoId: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  downloads: PropTypes.shape({
    edges: PropTypes.array.isRequired,
  }),
  note: PropTypes.string,
  access_token: PropTypes.string,
  isDisplayRepl: PropTypes.bool,
  trackSlug: PropTypes.string,
  stepId: PropTypes.number.isRequired,
  trackTopicName: PropTypes.string.isRequired,
};

export default TabbedContent;
